import { render } from "./HangManImage.vue?vue&type=template&id=2bd7993a&scoped=true"
import script from "./HangManImage.vue?vue&type=script&lang=js"
export * from "./HangManImage.vue?vue&type=script&lang=js"

import "./HangManImage.vue?vue&type=style&index=0&id=2bd7993a&scoped=true&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\VueJs\\hangman\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd7993a"]])

export default __exports__